import { RollbackOutlined, SaveOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, InputNumber, Select, Spin } from 'antd'
import { FormInstance } from 'antd/lib/form'
import React, { RefObject } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirebase, withFirestore } from 'react-redux-firebase'
import { withHandlers, withProps } from 'recompose'
import { compose } from 'redux'

import { withRouter } from 'react-router-dom'
import { SHOW_NOTIFICATION } from '../../../constants/ActionTypes'
import { ERROR, SUCCESS } from '../../../constants/notifications'
import {
  batchReprocessTournamentPlayers,
  findInOrdered,
  fsCollections,
  makeInBatchWithFirebase,
  withoutUndefined,
} from '../../../helpers/firestore'
import authorize from '../../higher-order/authorize'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
}

class TournamentCategoryForm extends React.Component<any, any> {
  formRef: RefObject<FormInstance<any>> = React.createRef()

  handleSubmit = (values) => {
    const { category, championshipCategory, onSubmit } = this.props

    const ranking = values.rankingId ? championshipCategory?.rankings[values.rankingId] : undefined

    onSubmit(
      withoutUndefined({
        ...values,
        id: category.id,
        main: category && category.main,
        ranking,
      }),
    )
  }

  handleFailure = ({ errorFields }) => {
    this.formRef?.current?.scrollToField(errorFields[0].name)
    /* TODO display somewhere */
    // tslint:disable-next-line:no-console
    console.log('Error during validation', errorFields)
  }

  render() {
    const {
      loading,
      categoryId,
      category,
      languages,
      previousLocation,
      goToPreviousLocation,
      championshipCategory,
    } = this.props
    const { getFieldValue } = this.formRef.current
      ? this.formRef.current
      : { getFieldValue: () => undefined }

    const currentMaxAge = getFieldValue('maxAge')
    const currentMinAge = getFieldValue('minAge')

    const minAgeAdditionalParams = currentMaxAge ? { max: currentMaxAge - 1 } : {}
    const maxAgeAdditionalParams = currentMinAge ? { min: currentMinAge + 1 } : {}

    const form = (
      <Form
        ref={this.formRef}
        onFinish={this.handleSubmit}
        onFinishFailed={this.handleFailure}
        initialValues={category}>
        {languages.map((language) => (
          <Form.Item
            key={language}
            {...formItemLayout}
            label="Name"
            hasFeedback
            name={`name:${language}`}
            rules={[{ required: true, message: 'Please input name!' }]}>
            <Input addonBefore={language} />
          </Form.Item>
        ))}
        <Form.Item {...formItemLayout} label="Level Filter" hasFeedback name="level">
          <Select allowClear>
            <Select.Option value="Novices">Novices</Select.Option>
            <Select.Option value="Other">Other</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...formItemLayout} label="Gender Filter" hasFeedback name="gender">
          <Select allowClear>
            <Select.Option value="Female">Female</Select.Option>
            <Select.Option value="Male">Male</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...formItemLayout} label="Age Filter">
          <Col span={12}>
            <Form.Item hasFeedback name="minAge">
              <InputNumber
                style={{ width: '10em' }}
                placeholder="Minimum"
                min={1}
                {...minAgeAdditionalParams}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item hasFeedback name="maxAge">
              <InputNumber
                style={{ width: '10em' }}
                placeholder="Maximum"
                {...maxAgeAdditionalParams}
              />
            </Form.Item>
          </Col>
        </Form.Item>
        {championshipCategory?.rankings && (
          <Form.Item {...formItemLayout} label="Championship Ranking" hasFeedback name="rankingId">
            <Select allowClear>
              {Object.values(championshipCategory.rankings).map((ranking: FIXME) => (
                <Select.Option key={ranking.id} value={ranking.id}>
                  {`${ranking.name} [${ranking.points}]`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
        <Form.Item {...tailFormItemLayout}>
          <Button.Group>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              Submit
            </Button>
            {previousLocation ? (
              <Button danger onClick={goToPreviousLocation} icon={<RollbackOutlined />}>
                Cancel
              </Button>
            ) : null}
          </Button.Group>
        </Form.Item>
      </Form>
    )

    return categoryId && loading ? <Spin>{form}</Spin> : form
  }
}

export default compose<FIXME>(
  authorize('admin'),
  withFirebase,
  withFirestore,
  withRouter,
  firestoreConnect<FIXME>(({ tenant, tournamentId }) => [
    { collection: fsCollections.tournaments(tenant), doc: tournamentId },
    { collection: fsCollections.globalPlayers(tenant) },
    { collection: fsCollections.tournamentCategories(tenant, tournamentId) },
    { collection: fsCollections.tournamentPlayers(tenant, tournamentId) },
  ]),
  connect(({ firestore }: FIXME, { tenant, tournamentId, categoryId }: FIXME) => ({
    category: findInOrdered(
      firestore.ordered[fsCollections.tournamentCategories(tenant, tournamentId)],
      categoryId,
    ),
    globalPlayers: firestore.ordered[fsCollections.globalPlayers(tenant)],
    tournament: findInOrdered(firestore.ordered[fsCollections.tournaments(tenant)], tournamentId),
    tournamentPlayers: firestore.ordered[fsCollections.tournamentPlayers(tenant, tournamentId)],
    tournamentCategories:
      firestore.ordered[fsCollections.tournamentCategories(tenant, tournamentId)],
  })),
  firestoreConnect<FIXME>(({ tenant, tournament, categoryId }) =>
    tournament?.championshipId && categoryId
      ? [
          {
            collection: fsCollections.championshipCategories(tenant, tournament.championshipId),
            doc: categoryId,
          },
        ]
      : [],
  ),
  connect(({ firestore }: FIXME, { tenant, tournament, categoryId }: FIXME) => ({
    championshipCategory:
      tournament?.championshipId && categoryId
        ? findInOrdered(
            firestore.ordered[
              fsCollections.championshipCategories(tenant, tournament.championshipId)
            ],
            categoryId,
          )
        : undefined,
  })),
  withHandlers<FIXME, FIXME>({
    goToPreviousLocation: ({ history, previousLocation }) => () => {
      if (previousLocation) {
        history.push(previousLocation)
      }
    },
    inBatchBound: makeInBatchWithFirebase,
  }),
  withHandlers({
    upsertSuccess: ({ dispatch, goToPreviousLocation }) => () => {
      dispatch({ type: SHOW_NOTIFICATION, message: 'Category saved', kind: SUCCESS })
      goToPreviousLocation()
    },
    upsertError: ({ dispatch }) => (err) => {
      // tslint:disable-next-line:no-console
      console.error('Failed to save category', err)
      dispatch({ type: SHOW_NOTIFICATION, message: 'Failed to save category', kind: ERROR })
    },
    upsertCategory: ({
      inBatchBound,
      tournamentId,
      categoryId,
      tenant,
      globalPlayers,
      tournament,
      tournamentCategories,
      tournamentPlayers,
    }) => (category) =>
      inBatchBound((firestore, batch) => {
        const collection = firestore.collection(
          fsCollections.tournamentCategories(tenant, tournamentId),
        )
        const categoryReference = categoryId ? collection.doc(categoryId) : collection.doc()

        batch.set(
          categoryReference,
          categoryId ? category : { ...category, main: tournamentCategories.length === 0 },
        )

        // we need to add new/updated category to the collection passed to players reprocessing
        const updatedTournamentCategories = [
          ...tournamentCategories.filter(
            (tournamentCategory) => tournamentCategory.id !== categoryId,
          ),
          { id: categoryReference.id, ...category },
        ]

        batchReprocessTournamentPlayers({
          tenant,
          tournamentId,
          tournament,
          globalPlayers,
          tournamentCategories: updatedTournamentCategories,
          tournamentPlayers,
        })(firestore, batch)
      }),
  }),
  withHandlers({
    onSubmit: ({ upsertCategory, upsertError, upsertSuccess }) => (category) =>
      upsertCategory(category)
        .then((res) => upsertSuccess(res))
        .catch((err) => upsertError(err)),
  }),
  withProps(
    ({
      category,
      tournament,
      tournamentCategories,
      globalPlayers,
      tournamentPlayers,
      championshipCategory,
    }) => ({
      loading: !isLoaded(
        category,
        tournament,
        tournamentCategories,
        globalPlayers,
        tournamentPlayers,
        tournament?.championshipId ? [championshipCategory] : [],
      ),
    }),
  ),
)(TournamentCategoryForm)



// WEBPACK FOOTER //
// ./src/components/tournament/management/TournamentCategoryForm.tsx